import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FrequentlyAsked.css";

const frequentlyAsked = "/images/frequently_asked.png";

const FrequentlyAsked = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState(0);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const handleLearnMore = () => {
    navigate("/faq-details");
  };

  const faqs = [
    {
      question: "What is NimbleBash?",
      answer:
        "NimbleBash is a complete event management platform that helps you organize, manage, and track events from start to finish. It includes mobile apps for guests and ushers, plus web-based.",
    },
    {
      question: "Who can use NimbleBash?",
      answer:
        "Event organizers use the it to create and manage events, ushers use the mobile app to check in guests and manage events, and guests use it to view their tickets and get checked in via QR codes.",
    },
    {
      question: "Is NimbleBash available for both iOS and Android?",
      answer: "Yes, the mobile app works on both iOS and Android devices.",
    },
    {
      question: "What if I encounter a bug or issue?",
      answer:
        "You can report issues directly using our contact support email nimblebashsupport@nimblebash.com . We take user feedback seriously and strive to resolve issues promptly.",
    },
    {
      question: "Can I make payment directly from the platform?",
      answer:
        "NimbleBash uses industry-standard security practices, including encrypted communication and secure data storage, to protect all user and event information.",
    },
  ];

  return (
    <section className="landing_page_faq">
      <div className="landing_page_faq_container">
        <div className="landing_page_faq_header">
          <div className="landing_page_faq_icon_container">
            <img
              src={frequentlyAsked}
              alt="Logo"
              className="landing_page_hero_icon"
            />
            <span className="landing_page_faq_title">
              Frequently asked Question
            </span>
          </div>
          <p className="landing_page_faq_subtitle">
            Find answers to commonly asked questions about our courses, program
            and platform
          </p>
          <button
            className="landing_page_faq_learn_more"
            onClick={handleLearnMore}
          >
            Learn More
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 15L12.5 10L7.5 5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="landing_page_faq_list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`landing_page_faq_item ${
                openFaqIndex === index ? "landing_page_faq_item_open" : ""
              }`}
            >
              <button
                className="landing_page_faq_question"
                onClick={() => toggleFaq(index)}
              >
                <span>{faq.question}</span>
                <div
                  className={`landing_page_faq_icon ${
                    openFaqIndex === index
                      ? "landing_page_faq_icon_rotated"
                      : ""
                  }`}
                >
                  {openFaqIndex === index ? "−" : "+"}
                </div>
              </button>
              {openFaqIndex === index && (
                <div className="landing_page_faq_answer">{faq.answer}</div>
              )}
            </div>
          ))}

          <button
            className="landing_page_faq_learn_more_mobile"
            onClick={handleLearnMore}
          >
            Learn More
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 15L12.5 10L7.5 5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default FrequentlyAsked;
